'use strict';

import ErrorAction from './registerErrorAction';

var Dispatcher = require('../dispatcher/appDispatcher');
var ActionType = require('../constants/actionType');
var AccountApi = require('../api/accountApi');
var AppError = require('./../utils/appError');

var RoutePath = require('./../constants/routePath')

/**
 * Account actions
 * @type {{getAccount: AccountAction.getAccount, saveAccount: AccountAction.saveAccount}}
 */
var AccountAction = {

  /**
   * Get account
   */
  async getAccount () {
    const response = await AccountApi.getAccount();
    if (AppError.isError(response)) {
      throw response;
    } else {
      Dispatcher.dispatch({
        actionType: ActionType.PROFILE_GET_ACCOUNT,
        account: response
      });
    }

    return response;
  },

  getCurrentProfileSettings: function () {
    return AccountApi.getAccount()
      .then(function (result) {
        Dispatcher.dispatch({
          actionType: ActionType.APP_PROFILE_SETTING_LOADED,
          account: result
        });
        Dispatcher.dispatch({
          actionType: ActionType.PROFILE_GET_ACCOUNT,
          account: result
        });
        return result;
      });
  },

  /**
   * Save account
   * @param accountItem account data
   */
  saveAccount: function (accountItem) {
    AccountApi.updateAccount(accountItem)
      .then(function (result) {
        if (result instanceof AppError) {
          Dispatcher.dispatch({
            actionType: ActionType.PROFILE_UPDATE_ACCOUNT_FAILURE,
            error: result
          });
        }
        else {
          Dispatcher.dispatch({
            actionType: ActionType.PROFILE_UPDATE_ACCOUNT,
            accountId: result
          });
        }
      });
  },

  /**
   * Act as account
   * @param user user data
   * @param router application router
   */
  actAsAccount: function (data, router) {
    AccountApi.actAsAccount(data).then(function (result) {
      if (result instanceof AppError) {
        Dispatcher.dispatch({
          actionType: ActionType.AUTH_ACT_AS_FAILURE,
          error: result
        });
      }
      else {
        Dispatcher.dispatch({
          actionType: ActionType.AUTH_ACT_AS,
        });

        Dispatcher.dispatch({
          actionType: ActionType.AUTH_LOGOUT,
        });

        router.push(RoutePath.ROUTE_LOGIN + (result || ""));
      }
    });
  },

  getPermissions() {
    return AccountApi.getPermissions().then(function (result) {
      if (!(result instanceof AppError)) {
        Dispatcher.dispatch({
          actionType: ActionType.GET_ACCOUNT_PERMISSIONS,
          payload: result
        });
      }
    });
  },

	toggleUploadAvatarDialog(state = false) {
  	Dispatcher.dispatch({
			actionType: ActionType.PROFILE_TOGGLE_UPLOAD_AVATAR_DIALOG,
			state: Boolean(state)
  	})
	}

};

module.exports = AccountAction;


